import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import { Form, Input, notification, Icon, Modal, Tooltip } from "antd";
import Header from "../../User/Header";
import { GlobalContext } from "../../app/providers/GlobalState";
import axios from "axios";
import moment from "moment";

const confirm = Modal.confirm;
const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

class VideoConfInscricao extends Component {
    static contextType = GlobalContext;
    state = {
        nome: "",
        email: "",
        contacto: "",
        //METTING
        meeting_assunto: "",
        meeting_data_hora: "",
        meeting_estado: false,
        gravarSessao: false,
        //LOADING
        iconLoading: false,
        //REDIRECT
        redirect: false
    };

    componentDidMount() {
        this.validarVideoconf();
    }

    handleChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };

    validarVideoconf = () => {
        axios({
            method: "get",
            url: "/api/pagina-entidade/validar-videoconferencia",
            params: {
                token: this.props.match.params.token
            }
        })
            .then(response => {
                this.setState(
                    {
                        meeting_assunto: response.data.assunto,
                        meeting_data_hora: `${moment(response.data.MeetingDate).format("DD/MM/YYYY")} ${response.data.hora}`,
                        meeting_estado: response.data.estado,
                        gravarSessao: response.data.gravarSessao
                    },
                    () => this.mostrarMensagens()
                );
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Ocorreu um erro!");
            });
    };

    mostrarMensagens = () => {
        if (this.state.gravarSessao)
            confirm({
                title: "Esta sessão está a ser gravada!",
                okText: "Continuar",
                okType: "Cancelar",
                onOk: () => {},
                onCancel: () => {
                    this.setState({
                        redirect: true,
                        redirectLink: `/${this.props.match.params.entidade}`
                    });
                }
            });
    };

    //ENVIA A INSCRICAO PARA PODER ACEDER A VIDEOCONFERENCIA
    Enviar = () => {
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.setState({ iconLoading: true });

                var item = new FormData();
                item.append("nome", this.state.nome);
                item.append("email", this.state.email);
                if (this.state.contacto) item.append("contacto", this.state.contacto);
                item.append("entidadeUrl", this.props.match.params.entidade);
                item.append("token", this.props.match.params.token);

                axios({
                    method: "post",
                    url: "/api/pagina-entidade/videoconferencia-inscricao",
                    data: item
                })
                    .then(response => {
                        localStorage.setItem("videoconf_userid", response.data[1]);
                        this.setState({
                            iconLoading: false,
                            redirect: true
                        });
                    })
                    .catch(() => {
                        openNotificationWithIcon("error", "Erro", "Não foi possível realizar inscrição!");
                        this.setState({ iconLoading: false });
                    });
            }
        });
    };

    render() {
        const { getFieldDecorator } = this.props.form;
        const { TextArea } = Input;

        if (this.state.redirect) return <Redirect to={`/${this.props.match.params.entidade}/vsc/${this.props.match.params.token}`} />;

        const {
            //METTING
            meeting_assunto,
            meeting_data_hora,
            meeting_estado,
            //LOADING
            iconLoading
        } = this.state;

        return (
            <>
                <Header titulo={meeting_assunto} tem_subtitulo subtitulo={meeting_data_hora} />
                <div className="container container-inscricao container-body">
                    <div className="content">
                        {!meeting_estado ? (
                            <Form className="suporte-contacto">
                                <h3 className="titulo-separador">dados da inscrição</h3>
                                <Form.Item label="Introduza o seu nome">
                                    {getFieldDecorator("nome", {
                                        rules: [
                                            {
                                                required: true,
                                                message: "Campo obrigatório"
                                            }
                                        ]
                                    })(<Input name="nome" onChange={this.handleChange} />)}
                                </Form.Item>
                                <Form.Item
                                    label={
                                        <>
                                            E-mail{" "}
                                            <Tooltip
                                                className="info-icon"
                                                className="info-icon info-icon2"
                                                title="E-mail onde receberá o código de acesso"
                                            >
                                                <Icon type="question-circle-o" />
                                            </Tooltip>
                                        </>
                                    }
                                >
                                    {getFieldDecorator("email", {
                                        rules: [
                                            {
                                                type: "email",
                                                message: "Introduza um endereço de e-mail válido"
                                            },
                                            {
                                                required: true,
                                                message: "Campo obrigatório"
                                            }
                                        ]
                                    })(<Input name="email" onChange={this.handleChange} />)}
                                </Form.Item>
                                <Form.Item label="Contato">
                                    {getFieldDecorator("contacto", {})(<Input name="contacto" onChange={this.handleChange} />)}
                                </Form.Item>
                                <div className="btn_plano">
                                    <Link to="#" className="botao-principal" disabled={iconLoading} onClick={this.Enviar}>
                                        {iconLoading ? <Icon type="loading" /> : null}
                                        Enviar
                                    </Link>
                                </div>
                            </Form>
                        ) : (
                            <Form className="suporte-contacto" style={{ textAlign: "center" }}>
                                <h2 style={{ marginBottom: 0 }}>Esta Stepmeet já terminou!</h2>
                            </Form>
                        )}
                    </div>
                </div>
            </>
        );
    }
}
const FormVideoConfInscricao = Form.create({ name: "video-conf-inscricao" })(VideoConfInscricao);

export default FormVideoConfInscricao;
